<template>
  <div class="swiper">
    <h2>{{ title }}</h2>
    <swiper :options="vendorSwiperOptions" ref="vendorSwiper">
      <swiper-slide v-for="shop in shops.data" :key="Math.random().toString(36).substr(2, 9)">
        <div class="card vendor-card">
          <div class="card-overlay">
            <button class="btn overlay" @click.prevent="goTo('shop', {id: shop.uid})">Zum Händler</button>
            <button class="btn icon outline green" @click.prevent="buyLive(shop)" v-if="shop.is_online">
              <span><icon class="icon" name="shopping-cart"></icon></span>
              <span>Jetzt live einkaufen</span>
            </button>
            <!-- <button class="btn orange">Aus Favoriten entfernen</button> -->
          </div>
          <span class="cat-label"><icon name="sliders" class="icon rotate-90"></icon><span>{{ shop.categories.data[0].name }}</span></span>
          <img-comp :element="shop" size="xs" :alt="shop.name"></img-comp>
          <div class="lg:hidden xl:hidden flex">
            <button :class="['btn orange inline-block w-1/2 rounded-none', shop.is_online ? 'w-1/2' : 'w-full' ]" @click.prevent="goTo('shop', {id: shop.uid})">Zum Händler</button>
            <button v-if="shop.is_online" class="btn icon green inline-block w-1/2 rounded-none" @click.prevent="buyLive(shop)" >
              <span><icon class="icon" name="shopping-cart"></icon></span>
              <span>Jetzt live einkaufen</span>
            </button>
          </div>
          <div class="text">
            <h3>{{ shop.name }}</h3>
            <span>Location </span>&#149;<span :class="shop.is_online ? 'open' : 'closed'" > {{ shop.is_online ? 'Offen' : 'Geschlossen' }} </span>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination-wrapper">
      <div class="icon outline vendor-swiper-prev">
        <icon name="chevron-left" scale="1.25"></icon>
      </div>
      <div class="vendor-swiper-pagination" slot="pagination"></div>
      <div class="icon outline vendor-swiper-next">
        <icon name="chevron-right" scale="1.25"></icon>
      </div>
    </div>
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    name: 'shopSlider',
    props: {
      shops: {
        type: Object,
        default: function () {
          return {
            data: [],
            links: {
              next: null
            }
          }
        },
        required: true
      },
      title: {
        type: String,
        default: ''
      }
    },
    mixins: [helpers, formatting],
    data () {
      return {
        vendorSwiperOptions: {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: '.vendor-swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.vendor-swiper-next',
            prevEl: '.vendor-swiper-prev'
          },
          breakpoints: {
            1300: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            713: {
              slidesPerView: 'auto',
              spaceBetween: 10
            }
          }
        }
      }
    },
    methods: {
      buyLive (shop) {
        if (this.isAuthenticated) {
          if (!this.buyLiveToast) {
            this.buyLiveToast = this.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
            var self = this
            this.getInLine({
              shop: shop.uid,
              cb () {
                self.$toasted.success('Du stehst jetzt bei ' + shop.name, {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              },
              errorCb () {
                self.$toasted.error('Einen Fehler ist aufgetreten, bitte versuch es nochmal oder kontaktiere unser Team', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              }
            })
          }
        } else {
          EventBus.$emit('toggleLoginModal')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/slider/shopSlider.vue